// extracted by mini-css-extract-plugin
export var linkContainer = "link-module--linkContainer--xGZnt";
export var link = "link-module--link--tO0X6";